// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "thead {\n  background-color: #f09a86;\n  color: black;\n}\n\ntbody {\n  font-size: smaller;\n}", "",{"version":3,"sources":["styles.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,YAAA;AACJ;;AAKA;EAEI,kBAAA;AAHJ","file":"styles.scss","sourcesContent":["thead{\n    background-color: #f09a86;\n    color: black;\n}\n// thead{\n//     background-color: #ee7e7e;\n// }\n\ntbody{\n    // text-transform: uppercase; \n    font-size: smaller;\n}\n"]}]);
// Exports
module.exports = exports;
